import * as React from 'react';

import type { DisclosureFavorite } from '../../../output/models';

import { PtsLink } from '../../../components/ServiceLink';

import { stockPath } from '../../../utils';

interface Props {
  disclosure: DisclosureFavorite;
}

export const DisclosureRow: React.FC<Props> = ({ disclosure }) => {
  return (
    <tr>
      <td className="border border-gray p-2 text-center md:px-1.25 md:py-1.5">
        <span className="whitespace-nowrap">{disclosure.release_date}</span>
      </td>
      <td className="border border-gray p-2 md:px-1.25 md:py-1.5">
        <div className="h-[17px] overflow-hidden">{disclosure.name}</div>
      </td>
      <td className="border border-gray p-2 md:px-1.25 md:py-1.5">
        <span className="flex justify-between">
          <a href={disclosure.pdf} target="_blank">
            {disclosure.title}
          </a>
          <span className="pl-1 pr-0.5">
            <PtsLink code={disclosure.code} />
          </span>
        </span>
      </td>
      <td className="border border-gray p-2 text-center md:px-1.25 md:py-1.5">
        <a href={stockPath(disclosure.code)} target="_blank">
          {disclosure.code}
        </a>
      </td>
    </tr>
  );
};
